import { sagaCreator } from '@adrias-online/steiner';

import helper from 'helpers/steinerHelper';
import { actions, actionTypes } from '../actions/coefficienti';
import { selectors, DEFAULT_STATE } from '../reducers/coefficienti';
import api from '../apis/coefficienti';

const sagas = helper.createSagas('coefficienti', actionTypes, actions, api, selectors, DEFAULT_STATE);

const defaultSagas = sagaCreator.bootSagas(sagas, actionTypes);

export default [
    ...defaultSagas
];